import { useState } from 'react';
import { Button, Row, Col, Container, InputGroup, FormControl, Card, Table, Modal } from 'react-bootstrap';
import MyInput from './MyInput';
import GenerePdf from './GenerePdf';

const GenerePdfManuel = () => {
    const [data, setData] = useState({
        nom_de_l_entreprise: '', civilite: '', prenom_adherent: '', nom_adherent: '',
        adresse1: '',
        code_postal: '', ville: '', annee_facture: '',
        facture: '',
        date_facture: '',
        libelle_facture: '',
        numero_facture: '',

        tableau1: [],
        somme: 0,

        paiements: [{ date_paiement: '', type: '', montant: '' }],
    });
    const [showNewArticle, setShowNewArticle] = useState(false);

    const [goGenerePdf, setGoGenerePdf] = useState(false);

    const dropdown = JSON.parse(localStorage.getItem('dropdown'));

    const [myChoix, setMyChoix] = useState([]);
    const newArticleVide = { reference: '', designation: '', quantite: '', montant: '', remise: '', montant_total: '0' };
    const [newArticle, setNewArticle] = useState(newArticleVide);

    const saveNewArticle = () => {
        setMyChoix([...myChoix, newArticle]);
        setNewArticle(newArticleVide);
        setData({ ...data, tableau1: [...data.tableau1, newArticle] });
        setShowNewArticle(false);
    }

    const [requiredFields, setRequiredFields] = useState([]);
    const champs = [
        { lib: 'civilite', required: false },
        { lib: 'prenom_adherent', required: false },
        { lib: 'nom_adherent', required: false },
        { lib: 'adresse1', required: false },
        { lib: 'adresse2', required: false },
        { lib: 'code_postal', required: false, longueur: 5 },
        { lib: 'ville', required: false },
        { lib: 'nom_de_l_entreprise', required: false },
        { lib: 'libelle_facture', required: false },
        { lib: 'numero_facture', required: false },
        { lib: 'date_facture', required: false },
        { lib: 'somme', required: false },
        { lib: 'reference', required: false },
        { lib: 'designation', required: false },
        { lib: 'quantite', required: false },
        { lib: 'montant', required: false },
        { lib: 'remise', required: false },
        { lib: 'montant_total', required: false },

    ];

    const getInput = (key, libelle, field) => {
        // console.log('getInput', key, libelle, field);
        let champ = champs.find(el => el.lib === field);
        if (!champ) return <></>;

        let value = data[field];
        // console.log(value, typeof value, value.length, champ.longueur, value.length !== champ.longueur);
        if (champ.required && !requiredFields.map(e => e.field).includes(field))
            setRequiredFields([...requiredFields, { field: field, longueur: champ.longueur, key: key }]);

        // getInput('Adresse 1', 'adresse1', data.adresse1)
        // console.log('getInput', key, libelle, field, value, champ, `Value = "${value}"`, value && value.trim() === '' ? 'has-error' : 'pas d`errreur');
        return <>
            <InputGroup className={`mb-3 ${champ.required && ((champ.longueur && value.length !== champ.longueur) || value.length === 0) ? 'has-error' : ''}`} key={key + field}>
                <InputGroup.Text className={champ.required && ((champ.longueur && value.length !== champ.longueur) || value.length === 0) ? 'border-danger' : ''}>
                    {libelle}{champ.required && <span style={{ color: 'red' }}>&nbsp;*</span>}
                </InputGroup.Text>
                <FormControl
                    value={value}
                    onChange={(e) => handleInputChange(field, e.target.value)}
                    maxLength={champ.longueur}
                />
            </InputGroup>
            {champ.longueur && value.length !== champ.longueur && <div>
                {/* Add a message to inform that required fields are mandatory */}
                <p style={{ color: 'red' }}>Ce champ doit faire {champ.longueur} caractères</p>
            </div>}
        </>
    }

    console.log('civilite', dropdown.filter(el => el.type === 'civilite'))
    const handleInputChangeNewArticle = (field, value) => {
        setNewArticle({ ...newArticle, [field]: value });
    }

    const handleInputChange = (field, value) => {
        console.log(field, value);

        let newEditedAdherent = { ...data };
        if (field === 'code_postal') {
            newEditedAdherent = { ...data, [field]: value, numero_de_dpt: value.length >= 2 ? value.substring(0, 2) : '' };
        } else {
            newEditedAdherent = { ...data, [field]: value };
        }

        setData(newEditedAdherent);
    };

    return (
        <>
            <Container>
                <Row>
                    <Col>

                        {getInput('entreprise', 'Entreprise', 'nom_de_l_entreprise')}
                        {champs.find(el => el.lib === 'civilite') &&
                            <MyInput data={data} setData={setData} field='civilite' libelle='Civilité' options={dropdown.filter(el => el.type === 'civilite').map(el => (el.libelle))} required={true} />
                        }
                        {/* (                
                    getSelect('Civilité', 'civilite', dropdown.filter(el => el.type === 'civilite').map(el => (el.libelle)), data, setData)
                    )} */}
                        {getInput('infoAdhWaiting', 'Prénom', 'prenom_adherent')}
                        {getInput('infoAdhWaiting', 'Nom', 'nom_adherent')}
                    </Col>
                    <Col>
                        {getInput('infoAdhWaiting', 'Adresse 1', 'adresse1')}
                        {getInput('infoAdhWaiting', 'Adresse 2', 'adresse2')}
                        {getInput('infoAdhWaiting', 'Code Postal', 'code_postal')}
                        {getInput('infoAdhWaiting', 'Ville', 'ville')}
                    </Col>
                    <hr />
                    <Col>
                        {getInput('infoAdhWaiting', 'Libellé facture', 'libelle_facture')}
                        {getInput('infoAdhWaiting', 'Numéro facture', 'numero_facture')}
                        {getInput('infoAdhWaiting', 'Date facture', 'date_facture')}
                        {getInput('infoAdhWaiting', 'Somme', 'somme')}

                    </Col>
                </Row>
                <Card>
                    <Card.Header>Choix de cotisation</Card.Header>
                    {/* <Card.Body> */}
                    <Table striped bordered hover style={{ margin: 'auto', }}>
                        <thead>
                            <tr>
                                {/* <th>Ordre</th> */}
                                <th>Référence</th>
                                <th>Désignation</th>
                                <th>Quantité</th>
                                <th>Montant</th>
                                <th>Remise</th>
                                <th>Montant total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                myChoix.map((e) => (
                                    <tr>
                                        <td>{e.reference}</td>
                                        <td>{e.designation}</td>
                                        <td>{e.quantite}</td>
                                        <td>{e.montant}&nbsp;€</td>
                                        <td>{e.remise}&nbsp;%</td>
                                        <td>{e.montant_total}&nbsp;€</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </Table>
                    <Button variant="outline-primary" onClick={() => setShowNewArticle(true)} size='lg'>+</Button>

                </Card>
                <GenerePdf fichier='facture_new' data={data} go={goGenerePdf} setGo={setGoGenerePdf} visible={true} />
            </Container>

            <Modal size="xl" show={showNewArticle} onHide={() => setShowNewArticle(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Nouvel article</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <InputGroup className={`mb-3`}><InputGroup.Text>Référence</InputGroup.Text>
                        <FormControl value={newArticle.reference} onChange={(e) => handleInputChangeNewArticle('reference', e.target.value)} />
                    </InputGroup>
                    <InputGroup className={`mb-3`}><InputGroup.Text>Désignation</InputGroup.Text>
                        <FormControl value={newArticle.designation} onChange={(e) => handleInputChangeNewArticle('designation', e.target.value)} />
                    </InputGroup>
                    <InputGroup className={`mb-3`}><InputGroup.Text>Quantité</InputGroup.Text>
                        <FormControl value={newArticle.quantite} onChange={(e) => handleInputChangeNewArticle('quantite', e.target.value)} />
                    </InputGroup>
                    <InputGroup className={`mb-3`}><InputGroup.Text>Montant</InputGroup.Text>
                        <FormControl value={newArticle.montant} onChange={(e) => handleInputChangeNewArticle('montant', e.target.value)} />
                    </InputGroup>
                    <InputGroup className={`mb-3`}><InputGroup.Text>Remise</InputGroup.Text>
                        <FormControl value={newArticle.remise} onChange={(e) => handleInputChangeNewArticle('remise', e.target.value)} />
                    </InputGroup>
                    <InputGroup className={`mb-3`}><InputGroup.Text>Montant total</InputGroup.Text>
                        <FormControl value={newArticle.montant_total} onChange={(e) => handleInputChangeNewArticle('montant_total', e.target.value)} />
                    </InputGroup>
                    <Button variant="outline-secondary" onClick={() => setShowNewArticle(false)}>Annuler</Button>
                    <Button variant="outline-primary" onClick={() => saveNewArticle()}>Ajouter</Button>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default GenerePdfManuel;
